import { Reducer, combineReducers } from "redux";
import { createAction, getType, getReturnOfExpression } from "typesafe-actions";

export const machineActions = {
    machineFetched: createAction("MACHINE_FETCHED", (machine: CurrentMachineState) => ({ type: "MACHINE_FETCHED", payload: machine })),
    machineSaved: createAction("MACHINE_SAVED", (machine: CurrentMachineState) => ({ type: "MACHINE_SAVED", payload: machine })),
    machineCleared: createAction("MACHINE_CLEARED")
};

const returnOfActions = Object.values(machineActions).map(getReturnOfExpression);
type MachineAction = typeof returnOfActions[number];

export interface MachinesState {
    current: CurrentMachineState;
}

export interface CurrentMachineState {
    id: string;
    name: string;
    machineIconFilename: string;
    isDisabled: boolean;
}

const currentMachineReducer: Reducer<CurrentMachineState> = (state: CurrentMachineState = null, action: MachineAction) => {
    switch (action.type) {
        case getType(machineActions.machineFetched):
        case getType(machineActions.machineSaved):
            return action.payload;
        case getType(machineActions.machineCleared):
            return null;
        default:
            return state;
    }
};

export default combineReducers<MachinesState>({current: currentMachineReducer });


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/areas/infrastructure/reducers/machines.ts